// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.StoriesPage_main__k\\+U9H {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 50px;
}

.StoriesPage_section__k\\+Usf {
  text-align: center;
  position: relative;
  display: inline-block;
  margin: 0 auto;
  padding: 10px 20px;
}

/* Subtle, elegant subtitle */
.StoriesPage_sectionSubtitle__\\+St5R {
  display: block;
  font-weight: 600;
  font-size: 14px;
  color: #718096; /* Subtle slate gray */
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 6px;
  opacity: 0.85;
  transition: transform 0.3s ease;
}

/* The Main H1 Heading */
.StoriesPage_sectionTitle__qeBDN {
  color: #406343;
  font-size: 36px;
  font-weight: 800;
  margin: 0;
  position: relative;
  display: inline-block;
  padding-bottom: 12px;
  transition: color 0.3s ease;
}

/* Animated accent line underneath the title */
.StoriesPage_sectionTitle__qeBDN::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 3px;
  background: linear-gradient(90deg, transparent, #406343, transparent);
  border-radius: 2px;
  transition: width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* Interaction Effects */
.StoriesPage_section__k\\+Usf:hover .StoriesPage_sectionSubtitle__\\+St5R {
  transform: translateY(-2px);
}

.StoriesPage_section__k\\+Usf:hover .StoriesPage_sectionTitle__qeBDN::after {
  width: 100px; /* Line expands gracefully on hover */
}


.StoriesPage_main__k\\+U9H p {
    color: #7f7f7f;
    font-weight: bold;
    line-height: 1.8;
    margin-bottom: 10px;
}

.StoriesPage_container__Hwlu3 {
    width: 100%;
    max-width: 1200px;
    margin: 0 auto; 
    padding: 0 20px; 
    text-align: center;
}

.StoriesPage_bodyContent__klMGg {
    display: flex;
    gap: 50px;
    width: 100%;
}

.StoriesPage_para__xbNZ\\+ {
  margin-top: 75px;
  padding-bottom: 75px;
  font-size: 17px;
}

@media (min-width: 576px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-sm__urpn- {
        max-width: 540px;
        margin: 0 auto;
    }
}

@media (min-width: 768px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-md__5Zr\\+Q {
        max-width: 720px;
        margin: 0 auto;
    }
}

@media (min-width: 992px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-lg__fMcFi {
        max-width: 960px;
        margin: 0 auto;
    }
}

@media (min-width: 1200px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-xl__CnLoO {
        max-width: 1100px;
        margin: 0 auto;
    }
}

@media (min-width: 1400px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-xxl__m1yqy {
        max-width: 1220px;
        margin: 0 auto;
    }
}

@media (min-width: 1600px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-xxxl__qE6TF {
        max-width: 1400px;
        margin: 0 auto;
    }
}

@media (min-width: 1920px) {
    .StoriesPage_container__Hwlu3, .StoriesPage_container-4k__TD-fr {
        max-width: 1550px;
        margin: 0 auto;
    }
}

.StoriesPage_speeches__bw\\+cV.StoriesPage_section-before-footer__FvX3g {
    margin-bottom: 180px !important;
}

@media (max-width: 768px) {
    .StoriesPage_speeches__bw\\+cV.StoriesPage_section-before-footer__FvX3g {
        margin-bottom: 220px !important;
    }
    
    .StoriesPage_container__Hwlu3 {
        padding: 0 15px;
    }
    
    .StoriesPage_bodyContent__klMGg {
        flex-direction: column;
        gap: 20px;
    }
}

@media (max-width: 480px) {
    .StoriesPage_speeches__bw\\+cV.StoriesPage_section-before-footer__FvX3g {
        margin-bottom: 280px !important;
    }
    
    .StoriesPage_container__Hwlu3 {
        padding: 0 10px;
    }
    
    .StoriesPage_bodyContent__klMGg {
        gap: 15px;
    }
}






/* Medium devices */
@media (min-width: 768px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-md__5Zr\\+Q {
    max-width: 720px;
  }
}

/* Large devices  */
@media (min-width: 992px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-lg__fMcFi {
    max-width: 960px;
  }
}

/* Extra large devices  */
@media (min-width: 1200px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-xl__CnLoO {
    max-width: 1140px;
  }
}

/* XX-Large devices */
@media (min-width: 1400px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-xxl__m1yqy {
    max-width: 1320px;
  }
}

/* XXX-Large devices */
@media (min-width: 1600px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-xxxl__qE6TF {
    max-width: 1500px;
  }
}

/* 4K and larger displays */
@media (min-width: 1920px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-4k__TD-fr {
    max-width: 1800px;
  }
}









/* Medium devices  */
@media (min-width: 768px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-md__5Zr\\+Q {
    max-width: 720px;
  }
}

/* Large devices */
@media (min-width: 992px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-lg__fMcFi {
    max-width: 960px;
  }
}

/* Extra large devices */
@media (min-width: 1200px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-xl__CnLoO {
    max-width: 1140px;
  }
}

/* XX-Large devices */
@media (min-width: 1400px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-xxl__m1yqy {
    max-width: 1320px;
  }
}

/* XXX-Large devices*/
@media (min-width: 1600px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-xxxl__qE6TF {
    max-width: 1500px;
  }
}

/* 4K and larger displays */
@media (min-width: 1920px) {
  .StoriesPage_container__Hwlu3, .StoriesPage_container-4k__TD-fr {
    max-width: 1800px;
  }
}`, "",{"version":3,"sources":["webpack://./src/website/Stories/StoriesPage.module.css"],"names":[],"mappings":";AACA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc,EAAE,sBAAsB;EACtC,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA,8CAA8C;AAC9C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,kBAAkB;EAClB,2DAA2D;AAC7D;;AAEA,wBAAwB;AACxB;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY,EAAE,qCAAqC;AACrD;;;AAGA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,WAAW;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,cAAc;IAClB;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;AACJ;;AAEA;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;AACJ;;;;;;;AAOA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,yBAAyB;AACzB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF;;;;;;;;;;AAUA,oBAAoB;AACpB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;AAC3B;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\n.main {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-bottom: 50px;\n}\n\n.section {\n  text-align: center;\n  position: relative;\n  display: inline-block;\n  margin: 0 auto;\n  padding: 10px 20px;\n}\n\n/* Subtle, elegant subtitle */\n.sectionSubtitle {\n  display: block;\n  font-weight: 600;\n  font-size: 14px;\n  color: #718096; /* Subtle slate gray */\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-bottom: 6px;\n  opacity: 0.85;\n  transition: transform 0.3s ease;\n}\n\n/* The Main H1 Heading */\n.sectionTitle {\n  color: #406343;\n  font-size: 36px;\n  font-weight: 800;\n  margin: 0;\n  position: relative;\n  display: inline-block;\n  padding-bottom: 12px;\n  transition: color 0.3s ease;\n}\n\n/* Animated accent line underneath the title */\n.sectionTitle::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 50px;\n  height: 3px;\n  background: linear-gradient(90deg, transparent, #406343, transparent);\n  border-radius: 2px;\n  transition: width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n\n/* Interaction Effects */\n.section:hover .sectionSubtitle {\n  transform: translateY(-2px);\n}\n\n.section:hover .sectionTitle::after {\n  width: 100px; /* Line expands gracefully on hover */\n}\n\n\n.main p {\n    color: #7f7f7f;\n    font-weight: bold;\n    line-height: 1.8;\n    margin-bottom: 10px;\n}\n\n.container {\n    width: 100%;\n    max-width: 1200px;\n    margin: 0 auto; \n    padding: 0 20px; \n    text-align: center;\n}\n\n.bodyContent {\n    display: flex;\n    gap: 50px;\n    width: 100%;\n}\n\n.para {\n  margin-top: 75px;\n  padding-bottom: 75px;\n  font-size: 17px;\n}\n\n@media (min-width: 576px) {\n    .container, .container-sm {\n        max-width: 540px;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 768px) {\n    .container, .container-md {\n        max-width: 720px;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 992px) {\n    .container, .container-lg {\n        max-width: 960px;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 1200px) {\n    .container, .container-xl {\n        max-width: 1100px;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 1400px) {\n    .container, .container-xxl {\n        max-width: 1220px;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 1600px) {\n    .container, .container-xxxl {\n        max-width: 1400px;\n        margin: 0 auto;\n    }\n}\n\n@media (min-width: 1920px) {\n    .container, .container-4k {\n        max-width: 1550px;\n        margin: 0 auto;\n    }\n}\n\n.speeches.section-before-footer {\n    margin-bottom: 180px !important;\n}\n\n@media (max-width: 768px) {\n    .speeches.section-before-footer {\n        margin-bottom: 220px !important;\n    }\n    \n    .container {\n        padding: 0 15px;\n    }\n    \n    .bodyContent {\n        flex-direction: column;\n        gap: 20px;\n    }\n}\n\n@media (max-width: 480px) {\n    .speeches.section-before-footer {\n        margin-bottom: 280px !important;\n    }\n    \n    .container {\n        padding: 0 10px;\n    }\n    \n    .bodyContent {\n        gap: 15px;\n    }\n}\n\n\n\n\n\n\n/* Medium devices */\n@media (min-width: 768px) {\n  .container, .container-md {\n    max-width: 720px;\n  }\n}\n\n/* Large devices  */\n@media (min-width: 992px) {\n  .container, .container-lg {\n    max-width: 960px;\n  }\n}\n\n/* Extra large devices  */\n@media (min-width: 1200px) {\n  .container, .container-xl {\n    max-width: 1140px;\n  }\n}\n\n/* XX-Large devices */\n@media (min-width: 1400px) {\n  .container, .container-xxl {\n    max-width: 1320px;\n  }\n}\n\n/* XXX-Large devices */\n@media (min-width: 1600px) {\n  .container, .container-xxxl {\n    max-width: 1500px;\n  }\n}\n\n/* 4K and larger displays */\n@media (min-width: 1920px) {\n  .container, .container-4k {\n    max-width: 1800px;\n  }\n}\n\n\n\n\n\n\n\n\n\n/* Medium devices  */\n@media (min-width: 768px) {\n  .container, .container-md {\n    max-width: 720px;\n  }\n}\n\n/* Large devices */\n@media (min-width: 992px) {\n  .container, .container-lg {\n    max-width: 960px;\n  }\n}\n\n/* Extra large devices */\n@media (min-width: 1200px) {\n  .container, .container-xl {\n    max-width: 1140px;\n  }\n}\n\n/* XX-Large devices */\n@media (min-width: 1400px) {\n  .container, .container-xxl {\n    max-width: 1320px;\n  }\n}\n\n/* XXX-Large devices*/\n@media (min-width: 1600px) {\n  .container, .container-xxxl {\n    max-width: 1500px;\n  }\n}\n\n/* 4K and larger displays */\n@media (min-width: 1920px) {\n  .container, .container-4k {\n    max-width: 1800px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `StoriesPage_main__k+U9H`,
	"section": `StoriesPage_section__k+Usf`,
	"sectionSubtitle": `StoriesPage_sectionSubtitle__+St5R`,
	"sectionTitle": `StoriesPage_sectionTitle__qeBDN`,
	"container": `StoriesPage_container__Hwlu3`,
	"bodyContent": `StoriesPage_bodyContent__klMGg`,
	"para": `StoriesPage_para__xbNZ+`,
	"container-sm": `StoriesPage_container-sm__urpn-`,
	"container-md": `StoriesPage_container-md__5Zr+Q`,
	"container-lg": `StoriesPage_container-lg__fMcFi`,
	"container-xl": `StoriesPage_container-xl__CnLoO`,
	"container-xxl": `StoriesPage_container-xxl__m1yqy`,
	"container-xxxl": `StoriesPage_container-xxxl__qE6TF`,
	"container-4k": `StoriesPage_container-4k__TD-fr`,
	"speeches": `StoriesPage_speeches__bw+cV`,
	"section-before-footer": `StoriesPage_section-before-footer__FvX3g`
};
export default ___CSS_LOADER_EXPORT___;
